import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react'

const VALID_EMAIL = 'admin@n26.com'
const VALID_PASSWORD = '12345!'

type AuthContextValue = {
  isAuthenticated: boolean
  login: (email: string, password: string) => boolean
}

const AuthContext = createContext<AuthContextValue | null>(null)

type AuthProviderProps = {
  children: ReactNode
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const value = useMemo<AuthContextValue>(
    () => ({
      isAuthenticated,
      login: (email, password) => {
        const success = email === VALID_EMAIL && password === VALID_PASSWORD
        if (success) setIsAuthenticated(true)
        return success
      },
    }),
    [isAuthenticated]
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used within an AuthProvider')
  return context
}
